<template>
    <section class="relative w-full flex flex-col-reverse xl:flex-row lg:flex-col items-start justify-between font-poppins bg-white mt-24 md:mt-2 lg:mt-0 xl:mt-0 py-10 md:py-20 xl:py-12 xl:pt-12 md:pt-28 px-6 md:px-10 lg:px-12 xl:px-10 z-0 antialiased">
      <!-- Background Decoration -->
      <img src="@/assets/bg-1.svg" alt="Background Decoration" class="absolute xl:top-0 xl:right-0 lg:top-0 lg:right-0 md:top-0 md:right-0 z-10 w-full xl:w-auto lg:w-full md:w-full opacity-100 xl:block hidden">
      <img src="@/assets/bg 4.svg" alt="Background" class="absolute inset-0 lg:pt-28 w-full h-full object-cover z-10 xl:hidden">
      <img src="@/assets/bg.svg" alt="Background" class="absolute bottom-0 right-0 z-0 w-full xl:w-1/3 lg:w-auto opacity-100 ">
      <img src="@/assets/elemen.svg" alt="" class="absolute top-36 left-0 z-0 xl:block hidden">
    
      <div ref="textContent" class="w-full text-start pt-0 md:pt-20 xl:pt-10 xl:top-20 py-1 md:py-0 lg:-py-1 xl:px-10 opacity-0 transform translate-y-10 transition-all duration-700 ease-in-out relative z-10">
        <h2 class="text-2xl md:text-3xl xl:text-4xl font-semibold mb-3 xl:pt-10 lg:pt-10 text-start relative leading-tight xl:text-black lg:text-white md:text-white text-white antialiased ">
          Empower Your Business with 
          <span class="xl:text-[#186a85] lg:text-white md:text-white text-white relative pb-2 inline-block antialiased">
            Cutting-Edge Technology
            <svg class="absolute h-6 min-w-[50px] w-full -bottom-2 left-0 text-[#186a85]/30" 
                viewBox="0 0 100 10" preserveAspectRatio="none">
              <path d="M0 5 Q 25 9, 50 5 Q 75 0, 100 5" stroke="currentColor" stroke-width="2" fill="none"/>
            </svg>
          </span>
        </h2>
    
        <p class="mt-1 xl:text-black lg:text-white md:text-white text-white text-base md:text-md lg:text-lg xl:text-lg max-w-7xl text-justify font-light antialiased">
          From software development to IT consulting, we provide total technology solutions tailored to your needs. Let's innovate and grow together.
        </p>
    
        <a href="https://wa.me/628111623222?text=Halo,%20saya%20tertarik%20dengan%20produk%20Phisoft.%20Saya%20ingin%20mencari%20tahu%20lebih%20lanjut%20tentang%20produk%20ini!" 
        target="_blank" rel="noopener noreferrer"
        class="mt-6 inline-flex items-center px-2 py-4 lg:px-8 lg:py-4  bg-[#186a85] text-white border-2 border-[#186a85] font-medium rounded-full shadow-xl hover:bg-white hover:text-[#186a85] transition-all duration-300 transform hover:scale-105 text-sm md:text-base group">
        Chat with Us
      </a>
      </div>
    
      <div ref="imageContent" class="w-full xl:w-full -bottom-8 justify-center items-center relative left-20 top-10 p-6 mt-20 md:mt-0 hidden xl:flex opacity-0 transform translate-y-10 transition-all duration-700 ease-in-out z-10">
        <img src="@/assets/img1.svg" alt="Element Image" class="w-auto max-w-6xl pt-16 drop-shadow-xl hover:scale-105 transition-transform duration-500">
      </div>
    
    </section>
  </template>
 
<script>
import { nextTick } from 'vue';

export default {
  name: 'HomePage',
  mounted() {
    nextTick(() => {
      setTimeout(() => {
        if (this.$refs.textContent) {
          if (Array.isArray(this.$refs.textContent)) {
            this.$refs.textContent.forEach(el => el.classList.remove("opacity-0", "translate-y-10"));
          } else {
            this.$refs.textContent.classList.remove("opacity-0", "translate-y-10");
          }
        }

        if (this.$refs.imageContent) {
          if (Array.isArray(this.$refs.imageContent)) {
            this.$refs.imageContent.forEach(el => el.classList.remove("opacity-0", "translate-y-10"));
          } else {
            this.$refs.imageContent.classList.remove("opacity-0", "translate-y-10");
          }
        }
      }, 200);
    });
  }
};
</script>

<style>
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-100% / 2)); }
}

.animate-scroll {
  animation: scroll 80s linear infinite;
}

.animate-scroll:hover {
  animation-play-state: paused;
}
</style>